import React, { useEffect, useMemo } from 'react';
import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';
import { Gallery, GalleryContext, useGalleryContext } from '@yme/atoms/gallery';
import { Col, Container, Row } from '@yme/atoms/grid';
import { Skeleton } from '@yme/common/components/skeletons';
import { useWindowSize } from '@yme/common/hooks';
import { CardHeader } from '@yme/components/Destinations/ExperienceDetailsPage/components/ExperienceDetailsCard/components/CardHeader';
import { IndentWrapper } from '@yme/components/Separator';
import { getBloomreachModel, getGlobalSearchItemId, getIsInAuthor } from '@yme/selectors/common';
import { PixelPageView, setPixelPageView } from '@yme/utils/bloomreach';
import { getExperienceDetailsLoaded, getExperienceDetailsPageState } from '../../redux/selectors';
import { CardInfo } from './components/CardInfo';
import { Description } from './components/Description';
import { GALLERY_CONFIG } from './constants';
import { prepareGalleryData } from './helpers';
export function ExperienceDetailsCard({ isRemoveBottomIndent, formUrl, partnerDetailsPagePath, isInEditor, }) {
    const { expTitle, expAssets, primaryImage, expSeoPageTitle, expSeoPageDescription } = useSelector(getExperienceDetailsPageState);
    const isLoaded = useSelector(getExperienceDetailsLoaded);
    const globalSearchItemId = useSelector(getGlobalSearchItemId);
    const { productCatalog, contentCatalog } = useSelector(getBloomreachModel);
    const isInAuthor = useSelector(getIsInAuthor);
    const galleryContext = useGalleryContext();
    const { setGalleryData } = galleryContext;
    const { isInfiniteDesktopView } = useWindowSize();
    const items = useMemo(() => prepareGalleryData([primaryImage, ...expAssets]), [expAssets, primaryImage]);
    useEffect(() => {
        setGalleryData(items);
    }, [items, setGalleryData]);
    useEffect(() => {
        if (productCatalog &&
            contentCatalog &&
            globalSearchItemId &&
            (expSeoPageTitle || expTitle) &&
            !isInAuthor) {
            setPixelPageView(PixelPageView.CONTENT, {
                catalogs: [
                    {
                        name: contentCatalog,
                    },
                ],
                item_id: globalSearchItemId,
                item_name: expSeoPageTitle ?? expTitle,
                domain_key: productCatalog,
            });
        }
    }, [contentCatalog, expSeoPageTitle, expTitle, globalSearchItemId, isInAuthor, productCatalog]);
    const descriptionSkeleton = (React.createElement(Skeleton, { skeletonProps: {
            height: 400,
        } }));
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
        React.createElement(React.Fragment, null,
            React.createElement(Helmet, null,
                React.createElement("title", null, expSeoPageTitle ?? expTitle),
                React.createElement("meta", { name: "description", content: expSeoPageDescription ?? '', "data-react-helmet": "true" })),
            React.createElement(Container, null,
                React.createElement(Row, { mt: "82px", lgMt: "116px" },
                    React.createElement(Col, { lg: 7, md: 8 },
                        !isInfiniteDesktopView && (React.createElement(CardHeader, { isLoaded: isLoaded, isInEditor: isInEditor })),
                        React.createElement(GalleryContext.Provider, { value: galleryContext },
                            React.createElement(Gallery, { config: GALLERY_CONFIG })),
                        isInfiniteDesktopView &&
                            (isLoaded || isInEditor ? React.createElement(Description, null) : descriptionSkeleton)),
                    React.createElement(Col, { lg: 5, md: 8 },
                        React.createElement(CardInfo, { isLoaded: isLoaded, isInEditor: isInEditor, formUrl: formUrl, partnerDetailsPagePath: partnerDetailsPagePath }),
                        !isInfiniteDesktopView &&
                            (isLoaded || isInEditor ? React.createElement(Description, null) : descriptionSkeleton)))))));
}
ExperienceDetailsCard.displayName = 'ExperienceDetailsCard_AEMComponent';
